import ENV from '../env';

const api = {


   async getSurveys(source = 'WEBVIEW') {
      const body = JSON.stringify({ application_views: [ source.toUpperCase() ] })

      const response = await fetch(`${ENV.getMicroservicesUrl()}user-questions/users/surveys/personalized` , { headers: ENV.getHeaders(), method: 'POST', body } );
      return await response.json();
   },

    async answerQuestion(selectedAnswers, actualQuestion, surveyId, skipped = false) {
        const bodyRequest = { 
            survey_id: surveyId,
            question_id: actualQuestion.id,
            answers_id: [],
            input: "",
            skipped
        }
        if(actualQuestion.type === 'open') {
            bodyRequest.input = selectedAnswers
        } else {
            bodyRequest.answers_id = selectedAnswers
        }

        const body = JSON.stringify(bodyRequest)

        const response = await fetch(`${ENV.getMicroservicesUrl()}user-questions/users/answer` , { headers: ENV.getHeaders(), method: 'POST', body } );
        return await response.json();
    }

 
}

export default api;